/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { ApiResponse } from '@common/types/api';
import { ElasticQueryOpts, ElasticResponse, ElasticSearchAfter } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';

export class Country {
  alpha2: string;
  name: string;
  latitude: number;
  longitude: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  static list(query, sort, queryOpts: ElasticQueryOpts, size?: number, pit?: Nullable<string>, search_after?: Nullable<ElasticSearchAfter>): ElasticResponse<Country> {
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/countries`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            queryOpts: JSON.stringify(queryOpts ?? { deleted: false }),
            sort: JSON.stringify([{ 'name.keyword': 'asc' }, { 'alpha2.keyword': 'asc' }]),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static autocomplete(query, config) {
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/countries/search`, {
          signal: config.signal,
          params: {
            sequence_id: 1,
            query,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static getById(countryId): ApiResponse<Country> {
    return axiosInstance.get(`/api/v1/countries/${countryId}`).then((res) => ({ ...res.data }));
  }
}
